import { useCallback, useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import { Actions as CoreActions } from '@sitecore-search/core';
import { getSearchEventData } from '../utils/events.js';
import useBaseWidget from './useBaseWidget.js';
import useWidget from './useWidget.js';
import useWidgetQuery from './useWidgetQuery.js';
export const dispatchWidgetAppearAction = (dispatch, query) => {
    if (!query)
        return;
    const response = query.getLastResponse();
    const items = response?.content || [];
    dispatch({
        type: CoreActions.WIDGET_APPEAR,
        payload: {
            // eslint-disable-next-line camelcase
            items: items.map(({ id, source_id }) => ({
                id,
                // eslint-disable-next-line camelcase
                sourceId: source_id,
            })),
            request: getSearchEventData(query),
        },
    });
};
const useWidgetVisibility = () => {
    const { dispatch } = useBaseWidget();
    const { options: { visibility = {} } = {} } = useWidget();
    const query = useWidgetQuery();
    const lastResponse = query.getLastResponse();
    const { triggerOnce = true } = visibility;
    const shouldTrigger = useRef(true);
    const { ref, inView, entry } = useInView({ ...visibility, triggerOnce });
    const trigger = useCallback(() => {
        dispatchWidgetAppearAction(dispatch, query);
    }, [dispatch]);
    useEffect(() => {
        if (shouldTrigger.current && inView && lastResponse) {
            shouldTrigger.current = !triggerOnce;
            dispatchWidgetAppearAction(dispatch, query);
        }
    }, [dispatch, inView, entry, triggerOnce, lastResponse]);
    return { ref, inView, entry, trigger };
};
export default useWidgetVisibility;
